// Import react component and proptyes
import React, { Component, PropTypes } from 'react'

// Import elements for table list
import {Table, Thead, Th, Tr, Td, collapseTd} from 'components/reactable'
import { SelectWrapper } from '../../shared/select/SelectWrap'
import { ColorSelectWrapper } from '../../shared/select/ColorSelectWrapper'

// Import helper functions
import {map} from 'lodash/collection'
import moment from 'moment'
import {dateFormatter} from 'lib/helpers'
import NoResults from '../../noResults'

// Import styles for component
import styles from '../taskList.scss'

// Import libraries
import i18n from 'lib/i18n'
import c from 'state/constants'
import underscore from 'underscore'

// Setup translation group to agenda2
const _ = i18n('agenda2')

/**
 * Table list component
 *
 * Handles task list table events and listing
 */
export default class TableList extends Component
{
    /**
	 * Set the required property types for the component
	 */
	static propTypes = {
        items:React.PropTypes.array.isRequired,
        filterStatusValue: React.PropTypes.string,
        filterColorValue: React.PropTypes.array,
        toggleModal: React.PropTypes.func.isRequired,
        setEditAction: React.PropTypes.func.isRequired,
        filterAction: React.PropTypes.func.isRequired,
        colorOptions: React.PropTypes.object.isRequired,
        checkTableItemAction: React.PropTypes.func.isRequired,
        checkTableAllItemsAction: React.PropTypes.func.isRequired,
        setNotificationTypeAction: React.PropTypes.func.isRequired,
        setSendTaskModalState: React.PropTypes.func.isRequired,
        setTaskReaded: React.PropTypes.func.isRequired
    }

    constructor(props) {
		super(props)
		this.state = {visibilityOf: {}, showOverdue: false}
    }

    /**
     * Component will unmount eve
     */
    componentWillUnmount () {
        this.state = {visibilityOf: []}
    }

    /**
     * Generates buttons for delete, deleteAll and create
     *
     * return Html
     */
    actionButtons(checkedItemCount, items) {
        const { toggleModal,setNotificationTypeAction,setSendTaskModalState } = this.props

        return (
			<div className={styles.buttonContainer}>
				<input
					onClick={() => setNotificationTypeAction('deleteTasks')}
					disabled={!checkedItemCount}
					type="button"
					className={styles.greyButton}
					value={_("delete")}
				/>

                <input
					type="button"
					className={styles.greyButton}
                    value={_("sendTask")}
                    disabled={!checkedItemCount}
					onClick={() => {
                        setSendTaskModalState()
                    }}
				/>

				<input
					type="button"
					className={styles.greyButton + " enabled"}
					value={_("create")}
					onClick={() => toggleModal(c.TASK_MODULE_MODAL_NAME_MANAGE_TASK)}
				/>
			</div>
		)
    }

    /**
	 * Convert status to string for user experience
     *
     * @param boolean status The status of the task item
     *
     * @return String
	 */
	statusToString(status) {
		return (status === true) ? _('completed') : _('uncompleted')
    }

    /**
     * Handles visible items ids list
     */
    handleVisibleList = (visibleIds) => {
		const visibilityOf = {}
		for (const id of visibleIds) {
			visibilityOf[id] = true
		}
		this.visibleIds = visibleIds
		this.setState({visibilityOf})
    }

    handleCheckAll = () => {
        const { checkTableAllItemsAction} = this.props
        const visibleIds = this.visibleIds

		checkTableAllItemsAction(visibleIds)
    }

    handleOverdueToggle = () => {
        const { showOverdue } = this.state
        this.setState({showOverdue: !showOverdue})
    }

    render() {
        // Get the required properties for the component
        const { items, filterStatusValue, filterColorValue, setEditAction, toggleModal, filterAction, colorOptions, checkTableItemAction,setTaskReaded} = this.props

        const {visibilityOf, showOverdue} = this.state

        let filteredItems = items

        // Generate filtered items from items property
        filteredItems = items.filter(item => !item.hidden)
        filteredItems = filteredItems.filter(item => !item.isDeleted)

        // Show just overdue filter if overdue is checked
        if(showOverdue == true) {
            filteredItems = items.filter(item => !item.isDeleted ).filter((value, index) => {
                let currentState = value.hidden;

                if(currentState == false)
                {
                    if(value.isCompleted == false)
                    {
                        let currentDate = moment().set({hour:0, minute: 0, second: 0, millisecond: 0})
                        let itemEndDate = moment(value.endDate)

                        if(itemEndDate.isBefore(currentDate) || itemEndDate.isSame(currentDate))
                        {
                            return true
                        }
                    }

                    return false
                }
            })
        }

        const filterColorOptions = [
            ...colorOptions.defaultColors,
            ...colorOptions.userColors,
        ]

        if(filterColorValue && filterColorValue.length > 0)
        {
            filterColorOptions.push({
                colorCode: null,
                value: 'reset_filter',
                label: _('showAll')
              })
        }

        const checkedItemCount = filteredItems.reduce((a, b) => a + (b.checked ? 1 : 0), 0)
        const allSelected = filteredItems && filteredItems.length > 0 && filteredItems.every(item => (
			visibilityOf[item.id] ? item.checked : true
        ))


        // Set default filter status options
        const filterStatusOptions = [
            {value: 'showAll', label: _('showAll')},
            {value: 'showCompleted', label: _('showCompleted')},
            {value: 'showUncompleted', label: _('showUncompleted')},
        ]
        return(
            <div>
            { filteredItems && underscore.isArray(filteredItems) && (filteredItems[0] !== 'Too many rows') &&
                <Table
                    onVisibleChange={this.handleVisibleList}
                    topPaginationElemL={
                        [
                            <div key="x1z">
                                <SelectWrapper
                                    key="s"
                                    value= {filterStatusValue}
                                    options={filterStatusOptions}
                                    onChange={(v) => {
                                        filterAction(v.value, filterColorValue)
                                    }}
                                />
                            </div>,
                            <div key="x2z">
                                <ColorSelectWrapper
                                    key="s"
                                    value={filterColorValue}
                                    options={filterColorOptions}
                                    onChange={(v) => {
                                        filterAction(filterStatusValue, v)
                                    }}
                                    placeholder={_('show_all_colors')}
                                />
                            </div>,
                            <div key="x3z" className={styles.overdueWrapper}>
                                <input
                                    type="checkbox"
                                    checked={showOverdue}
                                    onChange={(v) => {
                                        this.handleOverdueToggle()
                                    }}
                                />
                                <label>{_('showOverdue')}</label>
                            </div>
                        ]
                    }
                    topPaginationElemR={this.actionButtons(checkedItemCount, filteredItems)}
                    filterable={[
                        "title",
                        "description",
                    ]}
                    ref={el => {this.table = el}}
                    id="table"
                    className="table"
                    sortable={[
                        {column: 'endDate', sortFunction: (a,b) => {
                          let current = moment(a, 'YYYY-MM-DDTHH:mm:ss.SSS').unix()
                          let next = moment(b, 'YYYY-MM-DDTHH:mm:ss.SSS').unix()

                          return current > next ? 1: -1
                        }},
                        {column: 'title', sortFunction: (a,b) => {
                          return a.toLowerCase().localeCompare(b.toLowerCase(), 'sv', {sensitivity: 'accent'});
                        }},
                        'status',
                        {
                          column: 'globalSort',
                          sortFunction: (a,b) => {
                            let dataA = a.split('|')
                            let dataB = b.split('|')

                            dataA[0] =  moment(dataA[0], 'YYYY-MM-DDTHH:mm:ss.SSS').unix()
                            dataA[1] = (dataA[1] == 'true') ? 1 : 0

                            dataB[0] =  moment(dataB[0], 'YYYY-MM-DDTHH:mm:ss.SSS').unix()
                            dataB[1] = (dataB[1] == 'true') ? 1 : 0

                            if(dataA[1] == dataB[1])
                            {
                                return dataA[0] > dataB[0] ? 1 : -1
                            }
                            else
                            {
                                return dataA[1] > dataB[1] ? 1 : -1
                            }
                          }
                        }
                    ]}
                    defaultSort={
                        {
                            column: 'globalSort',
                            direction: 'asc',
                        }
                    }

                    itemsPerPage={40}
                    pageButtonLimit={5}
                >
                    <Thead>
                        <Th column="checkbox" style={{width: '5%', textAlign: 'left'}}>
                            <input
                                type="checkbox"
                                checked={allSelected}
                                onChange={this.handleCheckAll}
                            />
                        </Th>
                        <Th column="status" style={{width: '10%', textAlign: 'left'}}>
                            <strong>{_("status")}</strong>
                        </Th>
                        <Th column="title" style={{width: '70%', textAlign: 'left'}}>
                            <strong>{_("title")}</strong>
                        </Th>
                        <Th column="endDate" style={{width: '15%', textAlign: 'left'}}>
                            <strong>{_("endDate")}</strong>
                        </Th>
                    </Thead>

                    {filteredItems.map((item, key) =>
                        <Tr
                            i={item.id}
                            key={key}
                            className={item.isUnreaded ? `${styles.unread}` : ''}
                            onClick={(ev) => {
                                setEditAction('manageTask', item.id)
                                toggleModal(c.TASK_MODULE_MODAL_NAME_MANAGE_TASK)
                                setTaskReaded(item)
                            }}
                        >
                            <Td column="checkbox" value={map(item, i => i).join(' ')} style={{width: '5%', textAlign: 'left'}}>
                                <div style={{width: 15}}>
                                    <input
                                        type="checkbox"
                                        onClick={ev => ev.stopPropagation()}
                                        onChange={ev => checkTableItemAction(ev, item.id)}
                                        checked={item.checked}
                                    />
                                </div>
                            </Td>
                            <Td column="status" style={{width: '10%', textAlign: 'left'}}>{this.statusToString(item.isCompleted)}</Td>
                            <Td column="title" value={item.title} style={{width: '70%'}}>
                                <div style={{paddingRight: '25px'}}>
                                    {item.title}
                                    {item.hexColor != null &&
                                        <div style={{
                                            background: item.hexColor,
                                            width: '18px',
                                            height: '18px',
                                            display: 'inline-block',
                                            margin: '-3px -25px 0px 0px',
                                            float: 'right',
                                        }}></div>
                                    }
                                </div>
                            </Td>
                            <Td
                                style={{width: '15%', textAlign: 'left'}}
                                column="endDate"
                                value={
                                    // a little hack with MongoDB id as timestamp for sorting
                                    (item.endDate && (item.endDate.toString() + item.id)) || ""
                                }
                            >
                                {item.endDate && dateFormatter(item.endDate) || ""}
                            </Td>
                            <Td
                                column="description"
                                value={item.description}
                            >
                                {item.endDate && dateFormatter(item.endDate) || ""}
                            </Td>
                            <Td
                                column="globalSort"
                                value={item.globalSort}
                            >
                              {item.globalSort}
                            </Td>

                        </Tr>
                    )}
                </Table>
            }
            { filteredItems && underscore.isArray(filteredItems) && filteredItems.length === 0 &&
				<NoResults type="tasks"/>
            }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/taskList/components/tableList.jsx